import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, MessageSquare } from 'lucide-react';
import { companyInfo } from '../mock';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '+91 ',
    project: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const targetWhatsApp = "919561774777"; 

    try {
      if (BACKEND_URL) {
        try {
          await axios.post(`${BACKEND_URL}/api/contact`, formData);
        } catch (err) {
          console.error("Backend sync failed, proceeding to WhatsApp...");
        }
      }

      const formattedProject = formData.project ? formData.project.replace(/-/g, ' ').toUpperCase() : 'General Inquiry';
      
      const whatsappMessage = 
        `*🏠 NEW INQUIRY: KIANA DEVELOPERS*%0A` +
        `--------------------------------%0A` +
        `*👤 Name:* ${formData.name}%0A` +
        `*📧 Email:* ${formData.email}%0A` +
        `*📞 Phone:* ${formData.phone}%0A` +
        `*🏗️ Project:* ${formattedProject}%0A` +
        `*💬 Message:* ${formData.message}%0A` +
        `--------------------------------%0A` +
        `_Sent via Kiana Developers Website_`;

      const whatsappURL = `https://wa.me/${targetWhatsApp}?text=${whatsappMessage}`;

      window.open(whatsappURL, '_blank');
      toast.success('Opening WhatsApp chat...');

      setFormData({
        name: '',
        email: '',
        phone: '+91 ',
        project: '',
        message: ''
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In <span className="text-amber-700">Touch</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ready to find your dream home? Reach out via WhatsApp for a priority response.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8">
          {/* Sidebar with All Contact Information */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
              <div className="space-y-6">
                {/* Phone Card */}
                <a href={`tel:${companyInfo.contact.phone}`} className="flex items-start space-x-4 group cursor-pointer">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Phone className="text-white" size={20} />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Call Us</div>
                    <div className="text-gray-900 font-semibold group-hover:text-amber-700 transition-colors">
                      {companyInfo.contact.phone}
                    </div>
                  </div>
                </a>

                {/* EMAIL CARD - RESTORED HERE */}
                <a href={`mailto:${companyInfo.contact.email}`} className="flex items-start space-x-4 group cursor-pointer">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Mail className="text-white" size={20} />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Email Us</div>
                    <div className="text-gray-900 font-semibold group-hover:text-amber-700 transition-colors break-all">
                      {companyInfo.contact.email}
                    </div>
                  </div>
                </a>

                {/* Address Card */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-white" size={20} />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Office Address</div>
                    <div className="text-gray-900 font-semibold leading-relaxed">
                      {companyInfo.contact.address}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Support Option */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-100 shadow-sm">
              <h4 className="text-lg font-bold text-gray-900 mb-2">Instant Support</h4>
              <p className="text-sm text-gray-600 mb-4">Click below to start an immediate WhatsApp conversation.</p>
              <button 
                onClick={() => window.open('https://wa.me/919561774777', '_blank')}
                className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-lg font-bold flex items-center justify-center space-x-2 transition-all shadow-md"
              >
                <MessageSquare size={20} />
                <span>Quick WhatsApp Chat</span>
              </button>
            </div>
          </div>

          {/* Form Section */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Send Message</h3>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Your Name *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-amber-500 outline-none" placeholder="John Doe" />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-amber-500 outline-none" placeholder="john@example.com" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-amber-500 outline-none" placeholder="+91" />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Interested Property</label>
                    <select name="project" value={formData.project} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-amber-500 outline-none bg-white cursor-pointer">
                      <option value="">Select Project</option>
                      <option value="sai-adinath-majestic">SAI ADINATH MAJESTIC</option>
                      <option value="madhuban-square">MADHUBAN SQUARE</option>
                      <option value="shanit-nagar">SHANIT NAGAR</option>
                      <option value="madhuban-heights">MADHUBAN HEIGHTS</option>
                      <option value="krk-gulmohor">KRK GULMOHOR</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Your Message *</label>
                  <textarea name="message" value={formData.message} onChange={handleChange} required rows="4" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-amber-500 outline-none resize-none" placeholder="How can we help you?"></textarea>
                </div>

                <button 
                  type="submit" 
                  disabled={isSubmitting} 
                  className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 px-8 rounded-lg font-bold flex items-center justify-center space-x-3 transition-all transform hover:scale-[1.01] active:scale-95 shadow-lg shadow-green-200"
                >
                  {isSubmitting ? <span>Processing...</span> : <><MessageSquare size={22} /><span>Submit via WhatsApp</span></>}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;